import useApiServices from './useApiServices';
import { globalAdminUrl } from './globalApi';
//
/**
 * @module AdminServiceService
 * @returns  it return All DataSource Apis
 */

const CallCenterService = {
  CallCentreList: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/call-center/list`, credential, token),

  CallCentreView: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/call-center/view`, credential, token),

  CallCentreStatus: (id, token) => useApiServices().getApi(`${globalAdminUrl}/status/${id}`, token),

  GetAllAssignableStatuses: (id, token) =>
    useApiServices().getApi(`${globalAdminUrl}/status/assignable-status/${id}`, token),

  UpdateStatus: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/status/updateStatus`, credential, token)

  // AddressType: (token) =>
  //   useApiServices().getApi(`${globalAdminUrl}/common/master-list/ADDRESS_TYPE`, token)
};

export default CallCenterService;
